export enum ButterCmsCollectionType {
  Contacts = "contacts",
}
